import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["position", "getPosition", "isVisible", "triggerRect", "style", "type", "className", "htmlProps"],
  _excluded2 = ["title", "description", "buttonOkLabel", "buttonDissmissLabel"],
  _excluded3 = ["label"];
import { forwardRef, useRef } from 'react';
import parseClassnames from "../helpers/parseClassnames";
import useRect from "../helpers/useRect";
import _getPosition from "./helpers/getPosition";
import getStylesAndCollissions from "./helpers/getStylesAndCollissions";
import { renderTriangleBasedOnCollisionsAndPosition } from "./Triangles";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TooltipContent = function TooltipContent(_ref, forwardedRef) {
  var _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'top' : _ref$position,
    _ref$getPosition = _ref.getPosition,
    getPosition = _ref$getPosition === void 0 ? _getPosition : _ref$getPosition,
    isVisible = _ref.isVisible,
    triggerRect = _ref.triggerRect,
    style = _ref.style,
    type = _ref.type,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    htmlProps = _ref.htmlProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  var ownRef = useRef(null);
  var ref = forwardedRef || ownRef;
  var tooltipRect = useRect(ownRef, isVisible);
  var _getStylesAndCollissi = getStylesAndCollissions(getPosition, triggerRect, tooltipRect, position),
    _getStylesAndCollissi2 = _slicedToArray(_getStylesAndCollissi, 2),
    absolutePositionStyles = _getStylesAndCollissi2[0],
    collisions = _getStylesAndCollissi2[1];
  if (type === 'large' && 'title' in rest) {
    var title = rest.title,
      description = rest.description,
      buttonOkLabel = rest.buttonOkLabel,
      buttonDissmissLabel = rest.buttonDissmissLabel,
      tooltipContentProps = _objectWithoutProperties(rest, _excluded2);
    return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread(_objectSpread({
      role: "tooltip",
      style: _objectSpread(_objectSpread({}, style), absolutePositionStyles),
      ref: ref,
      className: parseClassnames(className, "tw-absolute tw-rounded-[0.5rem] tw-p-0.8 tw-inline-block tw-w-[30rem] tw-pt-2 tw-px-2 tw-pb-1.2 tw-bg-neutral-light-100 tw-shadow-01")
    }, tooltipContentProps), htmlProps), {}, {
      children: /*#__PURE__*/_jsxs("span", {
        className: "",
        children: [/*#__PURE__*/_jsx("span", {
          className: "tw-font-label1 tw-mb-0.4 tw-line-clamp-1",
          children: title
        }), /*#__PURE__*/_jsx("span", {
          className: "tw-font-body5 tw-mb-0.4 tw-line-clamp-3",
          children: description
        }), /*#__PURE__*/_jsxs("span", {
          className: "tw-flex tw-mt-1.2",
          children: [buttonDissmissLabel && /*#__PURE__*/_jsx("button", {
            type: "button",
            children: buttonDissmissLabel
          }), buttonOkLabel && /*#__PURE__*/_jsx("button", {
            type: "button",
            className: "tw-ml-auto",
            children: buttonOkLabel
          })]
        })]
      })
    }));
  }
  if (type === 'small' && 'label' in rest) {
    var label = rest.label,
      _tooltipContentProps = _objectWithoutProperties(rest, _excluded3);
    return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread(_objectSpread({
      role: "tooltip",
      style: _objectSpread(_objectSpread({}, style), absolutePositionStyles),
      ref: ref,
      className: parseClassnames(className, "tw-absolute tw-rounded-[0.5rem] tw-p-0.8 tw-inline-block tw-font-body5 tw-z-dialog tw-pointer-events-none tw-whitespace-no-wrap tw-bg-neutral-dark-700 dark:tw-bg-neutral-light-200 tw-text-neutral-light-100 dark:tw-text-neutral-light-800")
    }, _tooltipContentProps), htmlProps), {}, {
      children: [renderTriangleBasedOnCollisionsAndPosition(collisions, position), label]
    }));
  }
  return null;
};
export default /*#__PURE__*/forwardRef(TooltipContent);